import React, { Component } from 'react'
import { Table, Button, Tooltip, Input ,Icon} from 'antd'
import API from '../../../services/API'


class CustomersListContainer extends Component {
	state = {
		data: [],
		loading: true,
		pagination: {},
		query:''
	}

	componentDidMount() {
		this.getData({
			page: 1,
        })
	}

	getData = ({ page = 1, filters = null, sorter = null }) => {

		let newQuery = ''
		if (filters) {
			const keys = Object.keys(filters)
			keys.forEach((k) => {
				if (filters[k].length) {
					newQuery += `&filter[${k}]=${filters[k][0]}`
				}
			})
		}
		if (sorter && Object.keys(sorter).length) {
			const order = sorter.order === 'descend' ? '-' : ''
			newQuery += `&sort=${order}${sorter.field}`
		}

		API.get(`/api/customers?per_page=10&page=${page}${newQuery}&include=customer_type`)
			.then((response) => {
				this.setState({
					data: response.data.data,
					pagination: {
						...this.state.pagination,
						total: response.data.total,
					},
					loading: false,
					query:newQuery
				})
			})
			.catch(() => {
				this.setState({
					loading: false,
				})
			})
	}

	handleSearch = (selectedKeys, confirm, column) => {
		confirm()
	}


	handleTableChange = (pagination, filters, sorter) => {
		const pager = { ...this.state.pagination }
		pager.current = pagination.current
		this.setState({
			pagination: pager,
			loading: true,
		})

		this.getData({
			page: pagination.current,
			filters,
			sorter,
		})
	}

	getColumnSearchProps = (dataIndex) => ({

		filterDropdown: ({
			setSelectedKeys,
			selectedKeys,
			confirm,
			clearFilters,
		}) => (
			<div style={{ padding: 8 }}>
				<Input
					ref={(node) => {
						this.searchInput = node
					}}
					placeholder={`Search ${dataIndex}`}
					value={selectedKeys[0]}
					onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
					onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
					style={{ width: 188, marginBottom: 8, display: 'block' }}
				/>
				<Button
					type="primary"
					onClick={() => this.handleSearch(selectedKeys, confirm)}
					icon="search"
					size="small"
					style={{ width: 90, marginRight: 8 }}
				>
					Buscar
				</Button>
				<Button
					onClick={() => this.handleReset(clearFilters)}
					size="small"
					style={{ width: 90 }}
				>
					Cancelar
				</Button>
			</div>
		),
		filterIcon: (filtered) => (
			<Icon
				type="search"
				style={{ color: filtered ? '#1890ff' : undefined }}
			/>
		),
		onFilterDropdownVisibleChange: (visible) => {
			if (visible) {
				setTimeout(() => this.searchInput.select())
			}
		},
	})


	render() {
		const columns = [{
				title: 'Nombre',
				dataIndex: 'name',
				...this.getColumnSearchProps('name'),
			},
			{
				title: 'Apellido',
				dataIndex: 'last_name',
				...this.getColumnSearchProps('last_name'),
			},
			{
				title: 'Email',
				dataIndex: 'email',
				...this.getColumnSearchProps('email'),
			},
			{
				title: 'Tipo de precio',
				dataIndex: 'customer_type.name',
			},
			{
				title: 'RFC',
				dataIndex: 'rfc',
				...this.getColumnSearchProps('rfc'),
			},
			{
				title: 'Última actualización',
				dataIndex: 'updated_at',
			},
			{
				title: 'Acciones',
				dataIndex: '',
				key: 'x',
				render: (label, row) => (
					<div>
						<Button
							type="primary"
							shape="circle"
							icon="edit"
							size="small"
							style={{
								margin: 5,
							}}
							onClick={() => this.props.history.push(`/customers/edit/${row.id}`)}
						/>
						<Button type="primary" shape="circle" icon="info-circle" size="small" />
					</div>
				),
			}]
		return (
            <div>
					<div style={{ display: 'flex', padding: '16px 0' }}>
						<span style={{ flex: 1 }}> Listado de clientes </span>
						<Tooltip title="Generar hoja de calculo" placement="left">
							<Button style={{ marginRight: '10px' }} type="primary" shape="circle" icon="download" onClick={() => window.location.href='api/excel?table=customers&pagination=false&json=false'+this.state.query} />
						</Tooltip>
						<Tooltip title="Crear clientes" placement="left">
							<Button type="primary" shape="circle" icon="plus" onClick={() => this.props.history.push('/customers/create')} />
						</Tooltip>
					</div>
				<div>
					<Table
						columns={columns}
						rowKey={row => row.id}
						dataSource={this.state.data}
						pagination={this.state.pagination}
						loading={this.state.loading}
						onChange={this.handleTableChange}
						bordered
						size="small"
					/>
				</div>
            </div>
		)
	}
}

export default CustomersListContainer
